import { Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import DeleteIcon from '../../../../Components/Icons/Delete';
import EditIcon from '../../../../Components/Icons/Edit';
import { NuDate, NuInput, NuInputWithError, NuTextArea } from '../../../../Components/Utils/Input';
import DropDownAddMetaData, { DropDownAddUnitWithError } from '../../../../Components/Utils/selectAddMetaData';
import FormikSelectTwo, { SelectProductWithError } from '../../../../Components/Utils/Select';
import Attachement, { videotype } from '../../../../Components/Utils/CustomAttrachmentupload';
import Doc from '../../../../Components/Icons/Doc';
import Xls from '../../../../Components/Icons/Xls';
import Txt from '../../../../Components/Icons/Txt';
import Pdf from '../../../../Components/Icons/Pdf';
import CloseIcon from '../../../../Components/Icons/Close';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import UseProductDropDownNew from '../../../../Components/Hooks/useProductSearch';
import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import { useLocation, useParams } from 'react-router-dom';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import { useToast } from '../../../../Components/Others/ToastServices';
import * as yup from 'yup';
import Video from '../../../../Components/Icons/Video';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { SettingHeading } from '../../../../Components/Utils/Settingheading';
const filetype = [
    "docx",
    "doc",
    "xlsx",
    "xls",
    "pdf",
    "txt",
    "pptx",
    "mp4",
    "mov",
    "wmv",
    "avi",
    "flv",
    "mkv",
  ];

function EditInvoiceOutgoing() {
       const {value:Tax ,getData:refTax} = useFetchMataData(`/dropdown/dropdown-details/`,'Tax_Outgoing')
  const {value:ModeOfPayment ,getData:refModeOfPayment} = useFetchMataData(`/dropdown/dropdown-details/`,'paymentMethod')
  const {value:Division ,getData:refDivision} = useFetchMataData(`/dropdown/dropdown-details/`,'Division_invoices')
  const {value:paymentTerms ,getData:refpaymentTerms} = useFetchMataData(`/dropdown/dropdown-details/`,'paymentTerms')
  const {value:status ,getData:refstatus} = useFetchMataData(`/dropdown/dropdown-details/`,'Status_Outgoing')

    const { data: user } = UseDropDown('/user/new-drop-down');
      const { invoiceOutgoingEditId} = useParams();
  
    const {value:category ,getData:refcategory} = useFetchMataData(`/dropdown/dropdown-details/`,'Category_Outgoing')
  const { data: contract } = UseDropDown(`/contract/drop-down`);
   const {value:InvoiceType ,getData:refInvoiceType} = useFetchMataData(`/dropdown/dropdown-details/`,'Invoice_Type')
 
     
      const [image, setImage] = useState([]);
       const [fileRemoveList, setFileRemoveList] = useState([]);
          const location = useLocation();
      // const data = location.state?.data;
      const from = location.state?.from;
      console.log(location.state,'state');
          const { Oncancel, editFormData,contextHolder,isLoading } = useEditFormData();
    
      const [createNew, setCreateNew] = useState([])


       function getView() {
          axiosInstance 
            .get(`/invoices-outgoing/${invoiceOutgoingEditId}`)
            .then((res) => {
            res?.data?.data && setData(res?.data?.data);

              setCreateNew({
                amount: res?.data?.data?.amount,
          tax: String(res?.data?.data?.tax),
          totalAmount: res?.data?.data?.totalAmount,
          modeOfPayment: res?.data?.data?.modeOfPayment,
          daysElapsed: res?.data?.data?.daysElapsed,
          comments: res?.data?.data?.comments,
          contractId:res?.data?.data?.contractId,
          division:res?.data?.data?.division,
          ref:res?.data?.data?.ref,
          paymentDueDate:res?.data?.data?.paymentDueDate,
         filesToRemove: [],
          status:res?.data?.data?.status,
            taxAmount:res?.data?.data?.taxAmount,
            costCode:res?.data?.data?.costCode,
            description:res?.data?.data?.description,
          category:res?.data?.data?.category,
          debitTo:res?.data?.data?.debitTo,
          invoiceType:res?.data?.data?.invoiceType,
          receivedAmount:res?.data?.data?.receivedAmount,
          balanceAmount:res?.data?.data?.balanceAmount,
            receivedOn:res?.data?.data?.receivedOn,
          paymentTerms:res?.data?.data?.paymentTerms,
          ref:res?.data?.data?.ref,
          products:res?.data?.data?.products || [],
          attachments: res?.data?.data?.attachments  || [],

              });       
            })
            .catch(err=>{
              console.log("err", err);
            })
        }
        
        useEffect(() => {
          // if (!cData) {
            getView();
          // }
        }, [])
      const [combinedItems, setCombinedItems] = useState([]);
      const [remove, setRemove] = useState([]);
  
      const [selectedFile, setSelectedFile] = useState(null);
       const [filePathList, setFilePathList] = useState([]);
       const [removefilePathList, setRemoveFilePathList] = useState([]);
       const [isModalOpen, setIsModalOpen] = useState(false);
       const [selectedImage, setSelectedImage] = useState(null);
       const [fileExtention, setFileExtention] = useState("");
       const toast = useToast();
     
     function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };
     
       useEffect(() => {
         if (
          createNew?.attachments !== null &&
           createNew?.attachments !== "None" &&
           createNew?.attachments !== "[]"
         ) {
           console.log(createNew?.attachments, "ghjkllgd");
           setFilePathList(createNew?.attachments);
     
           setRemoveFilePathList(createNew?.attachments || []);
         }
       }, [createNew]);
     
       function UpdateAttachmentList(item) {
         let filterList = filePathList.filter((itemList) => itemList.file !== item);
         let removeFile = filePathList.find((itemList) => itemList.file === item);
         console.log("llll", filterList);
         setFileRemoveList([...fileRemoveList, removeFile.file]);
         setFilePathList(filterList);
       }
     
       function handleImageClick(img) {
         let Ext = img?.file_name.split(".").reverse()[0];
         setSelectedImage(img);
         setFileExtention(Ext);
         setIsModalOpen(true);
       } 
     
  
      const formik = useFormik({
          enableReinitialize: true,
          initialValues: createNew,
          validateOnChange: false,
          validateOnBlur: false,
          validationSchema: yup.object({
            // prId: yup.string().required('YPR is required!'),
            // coId: yup.string().required('Sales Order is required!'),
            amount: yup.string().required('amount is required!'),
            
      
          }),
          onSubmit: async (value, { resetForm }) => {
            // value.totalAmount=Number(value.totalAmount)
            // if (items.length === 0 && data?.products?.length === 0) {
            //   setError("Product table is empty");
            //   return;
            // }
            if ((items.length === 0) && (createNew?.products?.length === 0)) {
              setError("Product table is empty");
              return;
            }
            let formData = new FormData();
  
        const valueWithItems = {
          ...value,
          products: combinedItems,
          removedProducts: remove, 
          filesToRemove: fileRemoveList,
          
  
        };
        formData.append("json_data", JSON.stringify(valueWithItems));
        if (selectedFile !== null) {
          selectedFile.forEach((file) => {
            formData.append("attachments", file);
          });
        } else {
          formData.append("attachments", []);
        }
            // setLoading(true); 
              await editFormData({url:`/invoices-outgoing/edit-invoice/${invoiceOutgoingEditId}`,formData:formData,navigateUrl:from ||`/invoice/invoice-outgoing`,resetForm:resetForm})

              // setLoading(false)
          }
      })
  
    
      useEffect(() => {
        const amount = parseFloat(formik.values.amount || 0);
        const tax = parseFloat(formik.values.tax || 0);
        
        const taxAmount = ((amount)* tax/100);  
        
        formik.setFieldValue("taxAmount", taxAmount.toFixed(2));
        formik.setFieldValue("totalAmount", (amount + taxAmount).toFixed(2));
      }, [formik.values.amount, formik.values.tax]);
  
      useEffect(() => {
            const totalAmount = parseFloat(formik.values.totalAmount || 0);
            const receivedAmount = parseFloat(formik.values.receivedAmount || 0);
            
                formik.setFieldValue("balanceAmount", (totalAmount - receivedAmount).toFixed(2));
          }, [formik.values.totalAmount, formik.values.receivedAmount]);
      
          const [items, setItems] = useState([]);
      const [isEditQua, setIsEditQua] = useState(false);
      const [isEditReturnQua, setisEditReturnQua] = useState(false);
      const [data, setDatas] = useState([]);
    
      const [isEditUnit, setIsEditUnit] = useState(false);
     
      const [newItemData, setNewItemData] = useState({
        productName:"",
        purpose:"",
        quantity:"",
        returnedQty:"",
        unit:"",
        price:""
      });
      const [search, setSearch] = useState("");
     
        const [Item,setData] = useState([]);
      
     
    
      const { value: unit } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "Unit_item"
      );
  
         const [sortedProList,setSortedProList] =  useState([]);
         const [oldData, setOldData] = useState([])
        
       
         const [error, setError] = useState("");
           const [productError, setProductError] = useState("");
           const [unitError, setUnitError] = useState("");
           const [quantityError, setQuantityError] = useState("");

           const handleAdd = () => {
             let hasError = false;
         
             if (!formik.values.productName) {
               setProductError("Product is required");
               hasError = true;
             } else {
               setProductError("");
             }
         
             if (!formik.values.unit) {
               setUnitError("Unit is required");
               hasError = true;
             } else {
               setUnitError("");
             }
         
             if (!formik.values.quantity) {
               setQuantityError("Quantity is required");
               hasError = true;
             } else {
               setQuantityError("");
             }
         
             if (hasError) return;
         
             if (formik.values.productName && formik.values.quantity) {
              
               const newItem = {
                 productName: formik.values.productName,
                //  productName: sortedProList.find((i) => i.value === formik.values.productName),
                 quantity: formik.values.quantity,
                 price: formik.values.price,
                 unit: formik.values.unit,
               };
               setItems([...items, newItem]);
         
               setNewItemData({
                 productName: "",
                 unit: "",
                 quantity: "",
                 price:""
               });
            
                   formik.values.productName = "";
               formik.values.quantity = "";
               formik.values.unit = "";
               formik.values.price = "";

         
               setError("");
             }
           };
         
           const handleQuantityChange = (e, index) => {
             const updatedQuantity = e.target.value;
         
             const updatedItems = items.map((item, idx) => {
               if (idx === index) {
                 return { ...item, quantity: updatedQuantity };
               }
               return item;
             });
         
             setItems(updatedItems);
           };
       
           const handleReturnQuantityChange = (e, index) => {
             let updatedQuantity = parseInt(e.target.value, 10) || "";
             updatedQuantity = Math.max("", updatedQuantity); 
           
             setItems((prevItems) =>
               prevItems.map((item, idx) =>
                 idx === index
                   ? {
                       ...item,
                       returnedQty: updatedQuantity > item.quantity ? item.quantity : updatedQuantity, 
                     }
                   : item
               )
             );
           };
  
           useEffect(() => {
            if (Array.isArray(Item)) {
              const filterdItem = Item.filter(
                (drop) => !createNew?.products?.some((id) => id.productName === drop.value)
              );
          
              const union = Array.from(
                new Map([...filterdItem, ...oldData].map((item) => [item.value, item])).values()
              );
          
              const data = union.sort((a, b) => a.label.localeCompare(b.label));
              setSortedProList(data);
          
              console.log("item", Item);
            } else {
              console.warn("Item is not an array:", Item);
            }
          }, [Item]);
          
                 
                   useEffect(() => {
                     if (formik.values.productName) {
                       const findValue = sortedProList.filter((v) => formik.values?.productName ==(v.value));
                       console.log("final",findValue);
                       
                       setOldData(findValue);
                     }
                     console.log("Testing",formik.values.productName);
                   },[formik.values.productName])
                 const [finalList, setFinalList] = useState(createNew?.products);
           
         
                 const handleDeleteItem = (indexToDelete) => {
                  const updatedItems = items.filter((_, index) => index !== indexToDelete);
                  setItems(updatedItems);
                };
                
       
            const handleProductUnitChange = (value, index) => {
              console.log(value,"value");
  
               const updatedItems = items.map((item, idx) => {
                 if (idx === index) {
                   return { ...item, unit: value };
                 }
                 return item;
               });
               setItems(updatedItems);
               
             };
  
             const handleQuantityChangeAlredyExit = (e, index) => {
              const updatedItems = [...finalList];
              updatedItems[index].quantity = e.target.value;
              setFinalList(updatedItems);
              console.log("shsd", finalList);
            };
          
      
            const handleProductUnitChangeAlredyExit = (value, index) => {
              console.log(value,"value already ext");
              
              const updatedItems = [...finalList];
              updatedItems[index].unit = value;
              setFinalList(updatedItems);
              console.log("shsd", finalList);
            };
  
            useEffect(() => {
                      if (createNew?.products && items) {
                        const mergedArray = [...createNew.products, ...items];
                        setCombinedItems(mergedArray);
                      }
                    }, [createNew?.products, items]);
                    const handleDeleteProduct = (productName) => {
                      const updatedProducts = createNew.products.filter(
                        (product) => product.productName !== productName
                      );
                    
                      setCreateNew((prev) => ({
                        ...prev,
                        products: updatedProducts,
                      }));
                    };

                    useEffect(() => {
  if (formik.values.paymentDueDate && formik.values.receivedOn) {
    const dueDate = new Date(formik.values.paymentDueDate);
    const receivedDate = new Date(formik.values.receivedOn);
    
    // Calculate the difference in milliseconds
    const diffTime = receivedDate - dueDate;
    
    // Convert to days
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    
    // Set the daysElapsed value
    formik.setFieldValue('daysElapsed', diffDays);
  } else {
    // Reset if either date is missing
    formik.setFieldValue('daysElapsed', '');
  }
}, [formik.values.paymentDueDate, formik.values.receivedOn]);
                    
  
    return (
      <div className="w-full h-full py-2 px-4 ">
        <div className="flex justify-between ">
          {/* <Breadcrumb
            items={[
              {
                name: "Invoice-Outgoing",
                link: `/project/sales/invoice_outgoing/${officeId}/${projectId}`,
              },
              {
                name: "Edit",
              },
            ]}
          /> */}

          
          <Breadcrumb
                            items={[
                              // { name: "Invoice" },
                              {
                                name: "Outgoing",
                                link:"/invoice/invoice-outgoing"
          
                               
                              },
                  
                              { name: "Edit" },
                            ]}
                          />
  
          <BackButton />
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
            <div className=" w-full h-full py-4 px-3 flex justify-start content-start flex-wrap  overflow-y-auto">
             <div className="w-full">
        
                                       <SettingHeading title={`Schedule : ${createNew?.ref}` } />
                
            </div>
             <NuInput
                                      label="Description"
                                      type="text"
                                      formik={formik}
                                      placeholder="Description"
                                      name="description"
                                      width="w-full md:w-1/2 lg:w-2/3"
                                    />
                                    <NuInput
                                    type="text"
                                    label="Cost Code "
                                    placeholder="Cost Code"
                                    formik={formik}
                                    name="costCode"
                                    width="w-full md:w-1/2 lg:w-1/3"
                                    // isRequired={true}
                                  />
           
           <FormikSelectTwo
                              
                              type="text" 
                              label="Contract"
                              placeholder="Contract"
                              Options={contract}
                              formik={formik}
                              name="contractId"
                              width="w-full md:w-1/2 lg:w-1/3"
                              isRequired={true}
                            />
                     <FormikSelectTwo
                type="text"
                label="Debit To"
                placeholder="Debit To"
                Options={user}
                formik={formik}
                name="debitTo"
                width="w-full md:w-1/2 lg:w-1/3"
                // isRequired={true}
                FixPosition={false}
                PortalTarget={false}
              />
              <NuInput
                type="number"
                label="Amount"
                placeholder="Amount"
                formik={formik}
                name="amount"
                width="w-full md:w-1/2 lg:w-1/3"
              />
  
              <FormikSelectTwo
                type="text"
                label="Tax (%)"
                placeholder="Choose"
                Options={Tax}
                formik={formik}
                name="tax"
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={false}
                PortalTarget={false}
              />
   <NuInput
                type="number"
                label="Tax Amount"
                placeholder="Tax Amount"
                formik={formik}
                name="taxAmount"
                width="w-full md:w-1/2 lg:w-1/3"
                disabled={true}
              />
              <NuInput
                type="number"
                label="Total Amount"
                placeholder="Total Amount"
                formik={formik}
                name="totalAmount"
                width="w-full md:w-1/2 lg:w-1/3"
                disabled={true}
              />

              <NuInput
                            type="number"
                            label="Received Amount"
                            placeholder="Received Amount"
                            formik={formik}
                            name="receivedAmount"
                            width="w-full md:w-1/2 lg:w-1/3"
                            // disabled={true}
                          />
  
              
              
                                      <NuInput
                                                    type="number"
                                                    label="Balance Amount"
                                                    placeholder="Balance Amount"
                                                    formik={formik}
                                                    name="balanceAmount"
                                                    width="w-full md:w-1/2 lg:w-1/3"
                                                    disabled={true}
                                                  />
  
              <NuDate
                label="Payment Due Date"
                placeholder="Payment Due Date"
                formik={formik}
                name="paymentDueDate"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              {formik.values.receivedAmount && (
                                      <NuDate
                                        label="Received On"
                                        placeholder="Received On"
                                        formik={formik}
                                        name="receivedOn"
                                        width="w-full md:w-1/2 lg:w-1/3"
                                      />)}
            
              <FormikSelectTwo
                label="Mode Of Payment"
                placeholder="Choose"
                formik={formik}
                Options={ModeOfPayment}
                name="modeOfPayment"
                width="w-full md:w-1/2 lg:w-1/3"
              />
    <FormikSelectTwo
                type="text"
                label="Invoice Type"
                placeholder="Choose"
                Options={InvoiceType}
                formik={formik}
                name="invoiceType"
                width="w-full md:w-1/2 lg:w-1/3"
              />
  <FormikSelectTwo
                type="text"
                label="Category"
                placeholder="Choose"
                Options={category}
                formik={formik}
                name="category"
                width="w-full md:w-1/2 lg:w-1/3"
              />
  
  
              <FormikSelectTwo
                type="text"
                label="Division"
                placeholder="Choose"
                Options={Division}
                formik={formik}
                name="division"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               {/* <NuInput
                            type="number"
                            label="Days Elapsed"
                            placeholder="Days Elapsed"
                            formik={formik}
                            name="daysElapsed"
                            width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}

                            /> */}
               <FormikSelectTwo
              type="text"
              label="Payment Terms"
              placeholder="Payment Terms"
              Options={paymentTerms}
             formik={formik}
             name="paymentTerms"
             width="w-full md:w-1/2 lg:w-1/3"
            />
             <DropDownAddMetaData
                  label="Status"
                  placeholder="Choose"
                  Options={status}
                  formik={formik}
                  name="status"
                  width="w-full md:w-1/2 lg:w-1/3"
                  getFunc={refstatus}
                  displayProperty={"Status"}
                  propertyName={"Status_Outgoing"}
                />
             
              <NuTextArea
                label="Comments"
                placeholder="Comments"
                formik={formik}
                name="comments"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <div className="w-full">
                  <SettingHeading title="Attachment "  />
                  
                </div>
                <div className="md:flex justify-between mt-5 px-3 w-full">
                  <div className="w-full flex gap-2 items-center flex-wrap">
                    {createNew?.attachments &&
                      filePathList?.map((imgs, idx) => {
                        console.log("img", imgs);
                        let Ext = imgs?.file_name.split(".").reverse()[0];
                        return (
                          <div
                            className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                            key={idx}
                            style={{
                              border: "1px solid gray",
                              borderColor:
                                "rgb(148 163 184 / var(--tw-bg-opacity))",
                            }}
                          >
                            <div
                              className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                              onClick={() => UpdateAttachmentList(imgs?.file)}
                            >
                              <CloseIcon color="white" height="8" width="8" />
                            </div>
                            <div
                              className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                              onClick={() => handleImageClick(imgs)}
                            >
                              <div className=" w-8 h-8">
                                {videotype.includes(Ext) ? <Video /> : null}
  
                                {Ext === ("docx" || "doc" || "txt") ? (
                                  <Doc />
                                ) : Ext === ("xlsx" || "xls") ? (
                                  <Xls />
                                ) : Ext === "txt" ? (
                                  <Txt />
                                ) : Ext === "pdf" ? (
                                  <Pdf />
                                ) : Ext === "PDF" ? (
                                  <Pdf />
                                ) : Ext === "pptx" ? (
                                  <>No file</>
                                ) : (
                                  <img src={imgs?.file} alt="#" width="120%" />
                                )}
                              </div>
                              <p className=" w-[50px] text-[11px] truncate">
                                {imgs?.file_name}
                              </p>
                            </div>
                          </div>
                        );
                      })}
  
                    <Attachement 
                      handleChange={handleImageChange}
                      preview={image || ""}
                      width="w-full md:w-1/2"
                      label="Attach"
                      multiple={true}
                removeImages={removeImages}

                    />
                  </div>
                </div>
             
              <div className="w-full mx-auto h-auto bg-white rounded-md overflow-hidden mt-4 ">
              <div className=" w-full h-full flex justify-start content-start flex-wrap  overflow-y-auto mb-4">
                <div className="w-full">
                  <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                    Products :
                  </p>
                </div>
                <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                  <NuInputWithError
                                  label="Product"
                                  type="text"
                                  formik={formik}
                                  placeholder="Product"
                                  name="productName"
                                  width="w-full md:w-1/2 lg:w-[67%]"
                                  ErrMessage={productError}
                                />
                                  <NuInputWithError
                                  label="Unit"
                                  type="text"
                                  formik={formik}
                                  placeholder="Unit"
                                  name="unit"
                                  width="w-full md:w-1/2 lg:w-1/4 "
                                  ErrMessage={unitError}
                                />
                              
                                <NuInputWithError
                                  label="Quantity"
                                  type="number"
                                  formik={formik}
                                  placeholder="Quantity"
                                  name="quantity"
                                  width="w-full md:w-1/2 lg:w-1/4 "
                                  ErrMessage={quantityError}
                                />
                                 <NuInputWithError
                                  label="Price"
                                  type="number"
                                  formik={formik}
                                  placeholder="Price"
                                  name="price"
                                  width="w-full md:w-1/2 lg:w-1/4 "
                                  ErrMessage={quantityError}
                                />
                 
  
                  <button
                    onClick={handleAdd}
                    type="button"
                    className=" p-1 mt-10 m-1 text-center h-8 cursor-pointer bg-textColor-main border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                  >
                    Add
                  </button>
                </div>
                <div className="w-full bg-white overflow-hidden mt-5">
      {error && <p className="text-xs font-semibold text-red-500">{error}</p>}

      {/* Header Row (Desktop Only) */}
      <div className="hidden sm:flex w-full py-3 bg-textColor-main justify-between rounded-lg px-6">
        <p className="w-[5%] text-left text-white text-xs font-medium">S.No</p>
        <p className="w-[40%] text-left text-white text-xs font-medium">Product</p>
        <p className="w-[15%] text-center text-white text-xs font-medium">Unit</p>
        <p className="w-[15%] text-center text-white text-xs font-medium">Quantity</p>
        <p className="w-[20%] text-center text-white text-xs font-medium">Price</p>
        <p className="w-[5%] text-right text-white text-xs font-medium">Action</p>
      </div>

      {(items.length > 0 || createNew.products?.length > 0) ? (
        <div className="h-[calc(100vh-300px)] overflow-y-scroll">
          {[...items, ...createNew.products || []].map((List, index) => (
            <div
              key={index}
              className="w-full py-4 px-4 sm:px-6 border-b sm:flex sm:justify-between sm:items-center odd:bg-white even:bg-slate-50"
            >
              {/* Mobile layout */}
              <div className="sm:hidden text-xs text-[#111537] space-y-1 relative">
                {/* <div className="absolute top-2 left-2"> */}
                  <button
                    onClick={() => List?.productName ? handleDeleteProduct(List.productName) : handleDeleteItem(index)}
                    type="button"
                    className="absolute top-0 right-0 text-red-500 cursor-pointer"
                  >
                    <DeleteIcon color="red" height={12} />
                  </button>
                {/* </div> */}
                {/* <div className="pt-6"> */}
                  <p><span className="font-semibold">S.No:</span> {index + 1}</p>
                  <p><span className="font-semibold">Product:</span> {List?.productName || "-"}</p>
                  <p><span className="font-semibold">Unit:</span> {List?.unit || "-"}</p>
                  <p><span className="font-semibold">Quantity:</span> {List?.quantity || "-"}</p>
                  <p><span className="font-semibold">Price:</span> {List?.price || "-"}</p>
                {/* </div> */}
              </div>

              {/* Desktop layout */}
              <div  className="hidden sm:flex w-full justify-between items-center text-xs text-[#111537]">
                <p className="w-[5%] text-left">{index + 1}</p>
            <p className="w-[40%] text-left">{List?.productName || "-"}</p>
            <p className="w-[15%] text-center">{List?.unit || "-"}</p>
            <p className="w-[15%] text-center">{List?.quantity || "-"}</p>
            <p className="w-[20%] text-center">{List?.price || "-"}</p>
            <div className="w-[5%] text-right">
              <button
                onClick={() => handleDeleteItem(index)}
                type="button"
                className="text-red-500 cursor-pointer ml-2 border-none"
              >
                <DeleteIcon color="red" height={12} />
              </button>
            </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="w-full text-center text-[#93949f] py-4">
          No Items here
        </div>
      )}
    </div>
               
              </div>
            </div> 
                        <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading}/>
                </div>
              </div>
            </div>
          </div>
        </form>
        <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <img src={selectedImage?.file} alt={selectedImage?.file} />
        </Modal>
      </div>
    );
}

export default EditInvoiceOutgoing
